import { PatientInterface } from "@/api/Interfaces/PatientInterface";
import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";
import ServiceDetailProps from "@c/Home/Services/ServiceAppoint/ServiceDetail/ServiceDetailProp";
import Component from "vue-class-component";
import { mapGetters } from "vuex";
import { SelectTimeInterface } from "../../ServiceTimeSelect/SelectTimeInterface";
@Component({
  name: "ServiceDetail",
  computed: mapGetters(["getService", "getSearchDate", "getTime", "getPatientData"]),
})
export default class ServiceDetailComponent extends ServiceDetailProps {
  getTime!: SelectTimeInterface;
  getSearchDate!: string;
  getService!: ServiceInterface;
  getPatient!: PatientInterface;
  cx_name = this.name;
  cx_price = this.price;
  cx_localization = this.localization;
  cx_date = this.date;
  cx_time: SelectTimeInterface;
  cx_patient = this.patient;

  constructor() {
    super();

    this.cx_name = this.name;
    this.cx_price = this.price;
    this.cx_localization = this.localization;
    this.cx_date = this.date;
    this.cx_time = this.getTime;
  }

  mounted() {
    this.cx_name = this.name;
    this.cx_price = this.price;
    this.cx_localization = this.localization;
    this.cx_time = this.getTime;
  }

  formatDate(date: string) {
    const newDate = new Date(date);
    return newDate.toLocaleDateString("pt-BR", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: 'UTC'
    });
  }

  formattedCurrency(str: string): string {
    return parseFloat(str).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  maskCpf(document: string): string {
    const digits = String(document || "").replace(/\D/g, "");

    if (digits.length !== 11) {
      return document || "";
    }

    return `${digits.substring(0, 3)}.***.***-${digits.substring(9)}`;
  }
}
